import React from 'react';
import beefImage from '../images/product-photos/pack-shots/Fresh-packshot-beef.jpg';
import lambImage from '../images/product-photos/pack-shots/Fresh-packshot-lamb.jpg';
import turkeyImage from '../images/product-photos/pack-shots/Fresh-packshot-turkey.jpg';
import chickenPackImage from '../images/product-photos/pack-shots/Fresh-packshot-chicken.jpg';
import porkImage from '../images/product-photos/pack-shots/fresh-pork-pack-new.png';
import turkeyIngredientImage from '../images/onboarding-ingredients/turkey-breast.png';
import basilImage from '../images/onboarding-ingredients/ingredients-basil.png';
import saltImage from '../images/onboarding-ingredients/salt.png';
import peasImage from '../images/onboarding-ingredients/ingredients-peas.png';
import sweetPotatoImage from '../images/onboarding-ingredients/ingredients-sweet-potato.png';
import beefHeartImage from '../images/onboarding-ingredients/ingredients-beef-heart-kidney.png';
import blueBerriesImage from '../images/onboarding-ingredients/ingredients-blueberries.png';
import chickenImage from '../images/onboarding-ingredients/ingredients-chicken.png';
import dryChikenImage from '../images/recipes/dry/Dry Chicken/ProductCard-Drychicken-1.5.jpg';
import dryBeefImage from '../images/recipes/dry/Dry Beef/ProductCard-Drybeef-1.5.jpg';
import freshRecipesImage from '../images/recipes/types/ProductCard-Fresh-1.5.png';
import mixedRecipesImage from '../images/recipes/types/ProductCard-Mixed-1.5.png';
import dryRecipesImage from '../images/recipes/types/ProductCard-Dry-1.5.png';
import icon from '../images/onboarding-ingredients/health-benefits-02@2x.jpg';
import dogInBoxEmpty from '../images/dog-in-box-empty.png';
import idMeButton from '../images/Checkout/verify-with-idme-green@2x.png';
import { freshModalsContent } from '../testing/modalConstants';
import {
  US_STATE_OPTIONS,
  treatsDropdownsAndValues,
  supplementsDropdownsAndValues,
} from '../testing/constants';
import JerkyTreatBeefSweetPotatoImage from '../images/our-food/addons/JerkyTreats-BeefSweetPotato.jpg';
import JerkyBeefSweetPotatoTreatOrange from '../images/our-food/addons/Jerky-Beef-Sweet-Potato-Treat.jpg';
import JerkyTreatChickenAppleImage from '../images/our-food/addons/JerkyTreats-ChickenApple.jpg';
import SweetPotatoTreatImage from '../images/our-food/addons/StripTreats-SweetPotato.jpg';
import ZoomiesImage from '../images/our-food/addons/Supplements-Zoomies.png';
import ChillPillsImage from '../images/our-food/addons/Supplements-ChillPills.png';
import ProbioticsImage from '../images/our-food/addons/Probiotic-Chews.jpg';
// Recipes
export const recipes = [
  {
    title: 'Beef',
    label: 'Add',
    value: 'beef',
    benefit: 'Vitamin-Rich',
    description:
      'Hearty beef, sweet potatoes, and peas make for a well-rounded source of vitamins and minerals.',
    img: {
      src: beefImage.src,
      alt: 'beef recipe',
    },
    priceSymbol: 'low',
    UnavailableText:
      'Interested in our Fresh Beef Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
  {
    title: 'Turkey',
    label: 'Add',
    value: 'turkey',
    description:
      'Light and lean with turkey breast, kale, butternut squash, and blueberries.',
    benefit: 'Antioxidant Rich',
    img: {
      src: turkeyImage.src,
      alt: 'turkey recipe',
    },
    UnavailableText:
      'Interested in our Fresh Turkey Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    priceSymbol: 'mid',
    showMoreDetails: true,
  },
  {
    title: 'Chicken',
    label: 'Add',
    value: 'chicken',
    benefit: 'Sensitive Bellies',
    description:
      'A blend of chicken, rice, carrots, and peas that’s gentle on sensitive stomachs while still filling.',
    img: {
      src: chickenPackImage.src,
      alt: 'chicken recipe',
    },
    priceSymbol: 'mid',
    UnavailableText:
      'Interested in our Fresh Chicken Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
  {
    title: 'Lamb',
    label: 'Add',
    value: 'lamb',
    benefit: 'Allergy-Friendly',
    description:
      'Lamb, kale, and butternut squash deliver fiber and  essential nutrients while avoiding common allergens.',
    img: {
      src: lambImage.src,
      alt: 'lamb recipe',
    },
    priceSymbol: 'high',
    UnavailableText:
      'Interested in our Fresh Lamb Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
  {
    title: 'Pork',
    label: 'Add',
    value: 'pork',
    description:
      'Unique and lean meat great for pups prone to sensitives or allergies to common proteins.',
    img: {
      src: porkImage.src,
      alt: 'pork recipe',
    },
    benefit: 'Light and Lean',
    callout: 'New',
    priceSymbol: 'low',
    UnavailableText:
      'Interested in our Fresh Pork Recipe? Please contact our Canine Care team to find the pawfect plan for {{pupName}}!',
    showMoreDetails: true,
  },
];

export const dryRecipes = [
  {
    title: 'Chicken',
    label: 'Add',
    value: 'chicken',
    description:
      'A blend of chicken, rice, carrots, and peas that is gentle on sensitive stomachs, yet filling enough for insatiable pups.',
    img: {
      src: dryChikenImage.src,
      alt: 'chicken recipe',
    },
    showMoreDetails: true,
  },
  {
    title: 'Beef',
    label: 'Add',
    value: 'beef',
    description:
      'Packed with hearty beef, sweet potatoes, and peas for a well-rounded source of vitamins and minerals.',
    img: {
      src: dryBeefImage.src,
      alt: 'beef recipe',
    },
    showMoreDetails: true,
  },
];

export const planTypes = [
  {
    title: 'Fresh',
    label: 'Select',
    value: 'fresh',
    description: 'Slow-cooked real meat and veggies.',
    img: {
      src: freshRecipesImage.src,
      alt: 'fresh recipe',
    },
    pricingInfo: {
      discount: '$37.50',
      price: '$75.00/week',
    },
    badge: 'popular',
    showMoreDetails: false,
  },
  {
    title: 'Mixed',
    label: 'Select',
    value: 'mixed',
    description: 'Half Fresh. Half Baked. Whole food.',
    img: {
      src: mixedRecipesImage.src,
      alt: 'mixed recipe',
    },
    pricingInfo: {
      discount: '$37.50',
      price: '$75.00/week',
    },
    badge: 'new',
    showMoreDetails: false,
  },
];

export const collapsedPlanTypes = [
  {
    title: 'Baked',
    label: 'Select',
    value: 'dry',
    description: 'Gently baked real meat and veggies.',
    img: {
      src: dryRecipesImage.src,
      alt: 'dry recipe',
    },
    pricingInfo: {
      discount: '$37.50',
      price: '$75.00/week',
    },
    badge: 'new',
    showMoreDetails: false,
  },
];

// Ingredients
const beefHearts = {
  name: 'Beef hearts',
  description:
    'A muscle meat that is rich in minerals such as iron, selenium, phosphorus, and zinc.',
  image: { src: beefHeartImage, alt: 'Beef hearts' },
};

const sweetPotato = {
  name: 'Sweet potato',
  description:
    'A root veggie that is high in beta carotene, a powerful antioxidant and immune modulator.',
  image: { src: sweetPotatoImage, alt: 'Sweet potato' },
};

const peas = {
  name: 'Peas',
  description:
    'Rich in protein and high in fiber. Peas are high in lutein which promotes skin, heart and eye health.',
  image: { src: peasImage, alt: 'Peas' },
};

const chicken = {
  name: 'Chicken',
  description:
    'Rich in protein and high in fiber. Peas are high in lutein which promotes skin, heart and eye health.',
  image: { src: chickenImage, alt: 'Chicken' },
};

const blueberries = {
  name: 'Blue berries',
  description:
    'Rich in protein and high in fiber. Peas are high in lutein which promotes skin, heart and eye health.',
  image: { src: blueBerriesImage, alt: 'Blue berries' },
};

const salt = {
  name: 'Salt',
  description:
    'Rich in protein and high in fiber. Peas are high in lutein which promotes skin, heart and eye health.',
  image: { src: saltImage, alt: 'Salt' },
};

const turkey = {
  name: 'Turkey',
  description:
    'Rich in protein and high in fiber. Peas are high in lutein which promotes skin, heart and eye health.',
  image: { src: turkeyIngredientImage, alt: 'Turkey' },
};

const basil = {
  name: 'Basil',
  description:
    'Rich in protein and high in fiber. Peas are high in lutein which promotes skin, heart and eye health.',
  image: { src: basilImage, alt: 'Basil' },
};

const modalProps = name => ({
  headline: name,
  fullIngredients:
    'Beef, beef heart, sweet potato, peas, potato, beef kidney, carrot, beef liver, spinach, chia seed, dicalcium phosphate, blueberries, fish oil, iodized salt, zinc gluconate, rosemary, vitamin E supplement, pyridoxine hydrochloride (vitamin B6), riboflavin (vitamin B2), potassium iodide',
  nutritionalInfo: [
    {
      label: 'Protein:',
      value: 'min 9%',
    },
    {
      label: 'Fat:',
      value: 'min 7%',
    },
    {
      label: 'Fiber:',
      value: 'max 2%',
    },
    {
      label: 'Moisture:',
      value: 'max 70%',
    },
  ],
  body: (
    <div>
      Hearty Beef Eats is formulated to meet the nutritional levels established
      by the AAFCO Dog Food Nutrient Profiles for All Life Stages, including
      growth of large size Dogs (70 lbs or more as an adult). Calorie content
      (calculated): 1540 kcal ME/kg.
    </div>
  ),
});

export const mockedOffer = {
  amount: '60.00',
  category: 'CouponCategory.MARKETING',
  code: 'DEFAULT',
  formattedAmount: '60%',
  message: 'Get 60% OFF your starter box!',
  type: 'PERCENT_AMOUNT',
};

export const ingredientListProps = {
  header: 'Not-so-secret ingredients',
  subheader: 'Not-so-secret ingredients',
  defaultSelected: 'turkey',
  recipes: [
    {
      label: 'Beef',
      value: 'beef',
      modal: modalProps('Beef'),
      ingredients: [chicken, beefHearts, sweetPotato, peas],
    },
    {
      label: 'Chicken',
      value: 'chicken',
      modal: modalProps('Chicken'),
      ingredients: [peas, chicken, salt],
    },
    {
      label: 'Turkey',
      value: 'turkey',
      modal: modalProps('Turkey'),
      ingredients: [sweetPotato, peas, turkey],
    },
    {
      label: 'Lamb',
      value: 'lamb',
      modal: modalProps('Lamb'),
      ingredients: [beefHearts, sweetPotato, peas, basil, blueberries],
    },
  ],
};

// FAQ
export const FAQS = [
  {
    question: 'How is Ollie Made?',
    answer:
      'Short answer: with a whole lotta love. Longer answer: We started by working with a veterinary nutritionist who helped us formulate our balanced and complete, human-grade recipes, abiding by the AAFCO standards. Then we carefully sourced our ingredients (more on this below!), cook them at low temperatures in small batches at our facility in New Jersey, and hand-pack them. We personally know the people who are making the food—and our dogs can attest to how delicious it is.',
  },
  {
    question: 'Where are the ingredients sourced from?',
    answer:
      "Serious talk: We source our hormone-free* chicken and beef from high-quality, human-grade farms in the US. And our premium, pasture-raised lamb comes from free-range farms in the US and Australia. Our produce, seeds and oils are carefully sourced and there's absolutely no fillers, artificial flavoring, or preservatives in our food. Ever. *Federal regulations prohibit the use of hormones in poultry",
  },
  {
    question: 'When is it shipped?',
    answer:
      "Our food is shipped on a regular schedule according to your meal plan, and you can expect to get it on the same day each week. However, that date may change if there is a major holiday or when there's inclement weather. We will contact you if your shipment schedule changes.",
  },
  {
    question: 'When am I charged?',
    answer:
      'The card on your account is charged on a regular schedule in accordance with your shipments.',
  },
  {
    question: 'What if I’m not home when it’s delivered?',
    answer:
      'Ollie will stay fresh in the box until midnight on the day it arrives. But try to get the trays into your fridge as soon as you can when you get home so they stay cold. Ollie needs to chill!',
  },
  {
    question: 'How long will the food stay fresh after it’s delivered?',
    answer:
      'We use special modified atmospheric packaging to seal our trays so they’re airtight and keep our food fresh, without using any preservatives or chemicals. After you put it in the refrigerator, the food will be good to serve your dog for up to 4 days opened or unopened. Always remember to put the Ollie resealable lid on your tray after you’ve opened it to preserve the freshness.',
  },
  {
    question:
      'What if I don’t have enough room in my fridge to store the trays?',
    answer:
      'Whether or not you have enough room, you can always stash our food in your freezer—just as you would your own food that you want to preserve for a longer period of time. All you have to do is put it in your fridge to defrost 24 hours before you want to feed it to your dog.',
  },
];

// Testimonials
export const testimonials = [
  {
    icon,
    rating: 5,
    title: 'Smarter',
    body: 'Torquent accumsan purus et congue risus primis sodales sociosqu sit dignissim eu, penatibus libero vehicula suscipit erat rutrum suspendisse lectus cursus.',
    name: 'Daft and Punk',
  },
  {
    icon,
    rating: 5,
    title: 'Better',
    body: 'Ac hendrerit leo proin torquent tincidunt himenaeos, in auctor morbi neque natoque curae platea, penatibus et tellus gravida egestas.',
    name: 'Law and Order',
  },
  {
    icon,
    rating: 5,
    title: 'Faster',
    body: 'Quam sagittis tincidunt aliquet neque risus sapien ac lectus litora, platea tempor auctor mattis vehicula dignissim torquent luctus sollicitudin, integer ad quisque vestibulum pulvinar nibh rutrum arcu.',
    name: 'Bread and Circuses',
  },
];

// Starter box summary
const starterPlanProps = {
  recipes,
  summaryHeadline: `Hedwig's 2-week starter box`,
  totalPacks: 14,
  totalAmount: '48.90',
  amount: '24.45',
  period: 'week',
  ref: null,
  ctaText: 'Continue to checkout',
  onSubmit: () => {},
  discount: '50% off',
  discountValue: 50,
  defaultRecipes: ['beef'],
};

const dryBoxSummaryProps = {
  summaryHeadline: `Hedwig's 2-week starter box`,
  totalPacks: 14,
  ctaText: 'Continue to checkout',
  discount: '50% off',
  discountValue: 50,
};

export const planLoaderMessages = [
  {
    headline: 'Sit, Stay',
    text: "We're crunching some numbers to recommend the right amount of calories for {{pupName}}.",
  },
  {
    headline: 'Take your pick',
    text: 'Choose which recipes work best for your pup.',
  },
  {
    headline: 'Get {{discount}} off',
    text: 'Get your first two weeks of food and free goodies.',
  },
];

export const planLoaderBenefitsMessages = [
  {
    headline: "🙌 Creating {{pupName}}'s Plan",
    text: 'Creating the perfect portion and calorie plan.',
  },
  {
    headline: '🥕 Grabbing the best ingredients',
    text: 'Curating the most nutritious recipes for {{pupName}}.',
  },
  {
    headline: '🐶 Give them a longer life',
    text: 'Fresh recipes help dogs live up to 2.5 years longer.',
  },
];

export const planLoaderButtonText = 'View results';
export const planLoaderBenefitsButtonText =
  'View results and save {{discount}}';

export const starterBox = {
  sku: '2FR:20210621:A',
  tray_count: 21,
  cups_count: '1.0',
  weeks_of_food: '2',
  portion_of_pack_per_day: '1.0',
  percent_of_calories: '1.0',
  calories_per_day: '123',
  recommended_variant: '2FR:20210621:A[0.5B1-0.5C0]',
  variants: [
    {
      sku: '2FR:20210621:A[0.5B1-0.5C0]',
      price: '24.0',
      price_per_week: '12.0',
      recipes: {
        fresh: ['beef'],
      },
    },
    {
      sku: '2FR:20210621:A[0.5B1-0.5C1]',
      price: '24.0',
      price_per_week: '12.0',
      recipes: {
        fresh: ['beef', 'chicken', 'lamb', 'turkey'],
      },
    },
    {
      sku: '2FR:20210621:A[0.5B1-0.5C2]',
      price: '24.0',
      price_per_week: '12.0',
      recipes: {
        fresh: ['beef', 'turkey'],
      },
    },
  ],
};

export const dryStarterBox = {
  sku: '2FR:20210621:A',
  tray_count: 21,
  cups_count: '1.0',
  weeks_of_food: '2',
  portion_of_pack_per_day: '1.0',
  percent_of_calories: '1.0',
  calories_per_day: '123',
  recommended_variant: '2FR:20210621:A[0.5B1-0.5C0]',
  variants: [
    {
      sku: '2FR:20210621:A[0.5B1-0.5C0]',
      price: 24.0,
      price_per_week: 12.0,
      recipes: {
        dry: ['chicken'],
      },
    },
    {
      sku: '2FR:20210621:A[0.5B1-0.5C1]',
      price: 24.0,
      price_per_week: 12.0,
      recipes: {
        dry: ['beef'],
      },
    },
    {
      sku: '2FR:20210621:A[0.5B1-0.5C2]',
      price: 24.0,
      price_per_week: 12.0,
      recipes: {
        dry: ['chicken', 'beef'],
      },
    },
  ],
};

export const planSelectionProps = {
  body: [], // TODO(James) dummy CMS data here
  planSelectionInfo: {
    starterBox,
    items: recipes,
    headline: "Choose Penny's recipes",
    subheadline: (
      <>
        Penny needs <b>610 calories of food per day</b>. As a 20-pound active
        Corgi with an egg allergy, we made recipe recommendations to ensure her
        perfect portion. Continue with up to four selections below.
      </>
    ),
    periodPrice: '$12.00',
    discountedPeriodPrice: '$12.00',
    isSubmitting: false,
    modals: freshModalsContent,
    offer: mockedOffer,
    ...starterPlanProps,
  },
  noRecipesInfo: {
    headline: 'Doggone it!',
    subheadline:
      "We're unable to recommend a recipe for Penny at this time due to one or more allergies.",
    messagePreText: "You told us that Penny can't have:",
    messagePostText:
      "Double check this is accurate and adjust Penny's allergy profile to see available recipes",
    buttonText: "Edit Penny's allergies",
    onClick: () => {},
    secondaryButtonText: 'Back to Dashboard',
    onSecondaryButtonClick: () => {},
    image: {
      src: dogInBoxEmpty.src,
      alt: 'dog in empty box',
    },
    allergies: [
      { name: 'chicken' },
      { name: 'beef' },
      { name: 'lamb' },
      { name: 'turkey' },
    ],
  },
  ingredientInfo: ingredientListProps,
  faqInfo: {
    faqs: FAQS,
    headline: 'Learn more about Ollie',
  },
  testimonialInfo: {
    headline: 'What pups are saying',
    testimonials: testimonials,
  },
  planLoaderMessages,
  planLoaderButtonText,
};

export const dryRecipesSelectionProps = {
  starterBox: dryStarterBox,
  items: dryRecipes,
  headline: 'Choose Martin’s Baked recipes',
  subheadline: (
    <>
      Martin needs <b>610 calories of food per day.</b> As a 20-pound active
      Corgi with an egg allergy, we made recipe recommendations to ensure his
      perfect portion. Continue with up to two selections below.
    </>
  ),
  suggestedVariant: {
    price: 24.0,
    price_per_week: 12.0,
    discounted_price_per_week: 12.0,
  },
  modals: freshModalsContent,
  defaultRecipes: ['beef'],
  offer: mockedOffer,
  ...dryBoxSummaryProps,
};

export const productTypeSelectionProps = {
  headline: "How should we prepare Martin's food?",
  subheadline: (
    <>
      Each of our three prep options delivers fresh ingredients, delicious
      flavor, and complete nutrition — no byproducts or fillers, ever.
    </>
  ),
  ctaText: 'Continue',
  planTypes: planTypes,
  collapsedPlanTypes: collapsedPlanTypes,
  defaultPlanType: 'fresh',
  period: 'week',
};

// Checkout constants whaddup

export const plans = [
  {
    breeds: ['German Shepherd Dog'],
    petId: 'ba1cd921-6bde-41d9-a545-4b4428aed50f',
    petName: 'Trisha',
    frequency: 2,
    productType: 'DY',
    recipes: {
      dry: ['Chicken'],
      fresh: [],
    },
    numPacks: 0,
    bagCount: 2,
    price: '79.96',
    priceWithDiscount: '39.98',
    pricePerPeriod: '79.96',
    pricePerPeriodWithDiscount: '39.98',
    priceUnit: 'Week',
    gender: 'Female',
    addons: [],
  },
  {
    breeds: ['Maltese'],
    petId: 'a7244bba-f797-4519-bd97-b6cf718c7ba4',
    petName: 'Carrie',
    frequency: 2,
    productType: 'FR',
    recipes: {
      dry: [],
      fresh: ['Beef', 'Chicken', 'Turkey'],
    },
    numPacks: 14,
    bagCount: 0,
    price: '26.64',
    priceWithDiscount: '13.32',
    pricePerPeriod: '26.64',
    priceUnit: 'Week',
    pricePerPeriodWithDiscount: '13.32',
    gender: 'Female',
    addons: [],
  },
];

export const plansWithAllRecipeType = [
  // Dry
  {
    breeds: ['German Shepherd Dog'],
    petId: 'ba1cd921-6bde-41d9-a545-4b4428aed50f',
    petName: 'Trisha',
    frequency: 2,
    productType: 'DY',
    recipes: {
      dry: ['Chicken'],
      fresh: [],
    },
    numPacks: 0,
    bagCount: 1,
    pricePerPeriod: '79.96',
    pricePerPeriodWithDiscount: '39.98',
    priceUnit: 'Week',
    gender: 'Female',
    addons: [],
  },
  // Fresh
  {
    breeds: ['Maltese'],
    petId: 'a7244bba-f797-4519-bd97-b6cf718c7ba4',
    petName: 'Carrie',
    frequency: 2,
    productType: 'FR',
    recipes: {
      dry: [],
      fresh: ['Beef', 'Chicken', 'Turkey'],
    },
    numPacks: 14,
    bagCount: 0,
    pricePerPeriod: '26.64',
    pricePerPeriodWithDiscount: '13.32',
    priceUnit: 'Week',
    gender: 'Female',
    addons: [],
  },
  // Mixed
  {
    breeds: ['Border Collie'],
    petId: 'b6948bab-19ce-477e-8f08-6fa25925c9f5',
    petName: 'Drew',
    frequency: 2,
    productType: 'MX',
    recipes: {
      dry: ['Chicken', 'Beef'],
      fresh: ['Beef', 'Chicken', 'Turkey'],
    },
    numPacks: 14,
    bagCount: 2,
    pricePerPeriod: '26.64',
    pricePerPeriodWithDiscount: '13.32',
    priceUnit: 'Week',
    gender: 'Male',
    addons: [],
  },
];

export const longNamePlans = [
  {
    breeds: ['German Shepherd Dog'],
    petId: 'ba1cd921-6bde-41d9-a545-4b4428aed50f',
    petName: 'TrishaWithASuperLongName',
    frequency: 2,
    productType: 'DY',
    recipes: {
      dry: ['Chicken'],
      fresh: [],
    },
    numPacks: 0,
    bagCount: 1,
    pricePerPeriod: '79.96',
    pricePerPeriodWithDiscount: '39.98',
    priceUnit: 'Week',
    gender: 'Female',
  },
  {
    breeds: ['Maltese'],
    petId: 'a7244bba-f797-4519-bd97-b6cf718c7ba4',
    petName: 'Carrie',
    frequency: 2,
    productType: 'FR',
    recipes: {
      dry: [],
      fresh: ['Beef', 'Chicken', 'Turkey'],
    },
    numPacks: 14,
    bagCount: 0,
    pricePerPeriod: '26.64',
    pricePerPeriodWithDiscount: '13.32',
    priceUnit: 'Week',
    gender: 'Female',
  },
];

export const planSummary = {
  headline: "{{petName}}'s {{frequency}}-week starter box",
  numPacksCopy: '{{numPacks}} packs',
  recipesLabel: "{{petName}}'s recipes",
};

export const pricingList = {
  puptainerLabel: 'Puptainer',
  scooperLabel: 'Scoop',
  shippingLabel: 'Shipping',
  fooSubtotalLabel: 'Subtotal',
  bowlLabel: 'Bowl',
  subtotal: '45.98',
  discountLabel: 'Discount Applied',
  discountText: '20% off',
  discountAmount: '9.20',
  taxLabel: 'Tax',
  tax: '3.22',
  totalLabel: `Total`,
  total: '80.00',
  foodSubtotal: '40',
  foodDiscountText: '20% off',
  foodDiscountAmount: '20',
  addonsSubtotal: '12.00',
  promoCodeInfo: {
    promoCodeLabel: '{{defaultName}} code applied!',
    applyPromoCodeLabel: 'Apply',
    promoCodeAppliedLabel: '{{offerCode}} code applied!',
    removePromoCodeLabel: 'Remove code',
    errorPromoCodeLabel:
      'Promo code not applied. Please check your code and try again or reach out to Canine Care for help.',
    changePromoCodeLabel: 'Change code',
    newPromoCodeLabel: 'Enter new promo code',
  },
  showPromoCode: true,
};

export const checkoutButton = {
  text: 'Checkout',
};

export const termsAndConditions =
  '* By clicking checkout, I agree to receive the number of packs of Ollie food on the schedule specified above. I agree to be automatically charged for each shipment to my payment method on file. I can change or cancel my subscription at any time by emailing';

export const orderSummaryProps = {
  pricingList,
  planSummary,
  checkoutButton,
  termsAndConditions,
  addPupBtnLabel: 'Add another pup',
  period: 'week',
};

export const orderSummaryPropsWithoutAddons = {
  pricingList,
  planSummary,
  checkoutButton,
  termsAndConditions,
  addPupBtnLabel: 'Add another pup',
  period: 'week',
};

export const recurringOrdersProps = {
  foodPacksText:
    //eslint-disable-next-line no-template-curly-in-string
    "After {{pupName}}'s starter box, {{petPronoun}} plan will be billed and shipped every {{frequency}} weeks. ",
};

export const shippingAddressProps = {
  labelFirstName: 'First name',
  labelLastName: 'Last name',
  labelAddress: 'Address',
  labelApt: 'Apt/Suite (Optional)',
  labelZipCode: 'Zip code',
  labelCity: 'City',
  labelState: 'State',
  stateOptions: US_STATE_OPTIONS,
  labelPhoneNumber: 'Phone number',
  labelSMSUpdates: 'Send me SMS updates',
  labelSMSTerms:
    '*I agree to receive promotional marketing text messages from Ollie at the number provided. Consent is not a condition to purchase. Reply HELP for help and STOP to cancel.  Msg frequency varies. Msg and data rates may apply.',
  headerShippingAddress: '1. Shipping address',
};

export const accountInfoProps = {
  labelEmail: 'Email',
  labelPassword: 'Password',
  labelConfirmation: 'Confirm password',
  passwordTooltipContent: 'This is the tooltip',
  headerAccountInfo: '2. Account information',
};

export const idMeFormProps = {
  headerIDMeForm: '3. For our first responders',
  message: (
    <>
      Doctor, nurse, or a first responder? <strong>Get 50% OFF!</strong> You
      deserve it.
    </>
  ),
  buttonAlt: 'ID.me verify button. White text on a green background',
  buttonImage: idMeButton,
};

export const billingInformationProps = {
  headlineBillingInformation: '4. Billing Information',
  labelNameCard: 'Name on card',
  labelCardNumber: 'Card number',
  labelExpirationDate: 'Expiration date',
  labelCVC: 'CVC',
  labelWithStripe: 'Pay securely with Stripe.',
  placeholderNameCard: 'Name on card',
  placeholderCardNumber: '1234 1234 1234 1234',
  placeholderExpirationDate: 'MM/YY',
  placeholderCVC: 'CVC',
};

export const paymentElementLabels = {
  cardNumber: 'Card number',
  expiration: 'Expiration',
  zip: 'ZIP',
  cvc: 'CVC',
};

export const checkoutInfoProps = {
  plans: plans,
  orderSummary: orderSummaryPropsWithoutAddons,
  recurringOrders: {
    ...recurringOrdersProps,
    foodPacksText:
      // eslint-disable-next-line no-template-curly-in-string
      '{{pupName}} will receive {{numPacks}} food packs shipped every {{frequency}} weeks for ${{pricePerPeriod}} / week.',
  },
  nextDeliveryDate: '02/03/2021',
};

export const checkoutBarProps = {
  headline: "Doggy's 2-WEEK STARTER BOX",
  ctaText: 'Checkout',
  totalAmount: orderSummaryProps.pricingList.total,
  amount: '$24.45',
  period: 'week',
  discount: orderSummaryProps.pricingList.discount,
};

const commonProps = {
  headerText: "Hmm, something's not right.",
  errorMessage:
    "We weren't able to complete your request, please refresh the page and try again.",
};

export const serverSideErrorModalInfo = {
  onboarding: { ...commonProps },
  mealPlan: { ...commonProps },
  checkout: {
    headerText: "Your payment didn't go through",
    errorMessage: 'Please update your information or try a new payment method.',
  },
};

export const addonsProps = {
  addons: [
    {
      productName: 'Just Chicken Strips',
      quantity: 2,
      productType: 'TR',
      price: '24',
      discountedPrice: '12',
    },
    {
      productName: 'Chill Pills for Anxiety',
      quantity: 1,
      productType: 'SP',
      price: '32',
      discountedPrice: '16',
    },
  ],
};

export const PAYMENT_ERROR_MESSAGE =
  'There was an error processing your credit card';
export const PAYMENT_INSUFFICIENT_FUNDS_ERROR_MESSAGE =
  'Your payment method has insufficient funds';
export const ADDRESS_ERROR_MESSAGE = 'We are unable to process your address';
export const PASSWORD_ERROR_MESSAGE = 'We are unable to set your password';

const addonSkus = {
  beefjerky: 'JERKYSTRIPS-BE',
  chickenjerky: 'JERKYSTRIPS-CH',
  turkeyjerky: 'JERKYSTRIPS-TU',
  zoomies: 'ZOOMIES01',
  bellyrubs: 'BELLYRUBS01',
  chillpills: 'CHILLPILLS01',
  sweetpotatoes: 'SWEETPOTATOSLICES1',
  'dentalchews-xs': 'SUPP-DENT-XS',
  'dentalchews-s': 'SUPP-DENT-SM',
  'dentalchews-m': 'SUPP-DENT-MD',
  'dentalchews-l': 'SUPP-DENT-LG',
};

export const ADDON_PRODUCT_TYPES = {
  treats: 'TR',
  supplements: 'SP',
};

export const ADDON_PRODUCT_TYPES_LIST = Object.values(ADDON_PRODUCT_TYPES);

export const addons = [
  {
    sku: addonSkus.chickenjerky,
    productName: 'Chicken and Apple Jerky',
    title: 'Chicken and Apple Jerky',
    description: 'Simple and delicious, your dog will crave these treats.',
    productType: 'TR',
    subtitle: 'Jerky Treats',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: JerkyTreatChickenAppleImage.src,
      alt: 'Chicken And Apple Recipe Jerky Image',
    },
    dropdowns: treatsDropdownsAndValues.dropdowns,
  },
  {
    sku: addonSkus.beefjerky,
    productName: 'Beef and Sweet Potato Jerky',
    title: 'Beef and Sweet Potato Jerky',
    description:
      'Clean, simple treats to reward the best and bravest behavior.',
    productType: 'TR',
    subtitle: 'Jerky Treats',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: JerkyTreatBeefSweetPotatoImage.src,
      alt: 'Beef and Sweet Potato Recipe Jerky Image',
    },
    dropdowns: treatsDropdownsAndValues.dropdowns,
  },
  {
    sku: addonSkus.sweetpotatoes,
    productName: 'Sweet Potato Slices',
    title: 'Sweet Potato Slices',
    description:
      'One ingredient treats keep snack time simple, yet satisfying.',
    productType: 'TR',
    subtitle: 'Slice Treats',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: SweetPotatoTreatImage.src,
      alt: 'Sweet Potato Slices Image',
    },
    dropdowns: treatsDropdownsAndValues.dropdowns,
  },
  {
    sku: addonSkus.zoomies,
    productName: 'Zoomies',
    title: 'Zoomies',
    description:
      'For healthy hips and joints, this supplement will add some pep to their step.',
    productType: 'SP',
    subtitle: 'Hip and Joint Formula',
    size: '1 jar (60 chews)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: ZoomiesImage.src,
      alt: 'Hip and Joint Supplement Image',
    },
    dropdowns: supplementsDropdownsAndValues.dropdowns,
  },
  {
    sku: addonSkus.chillpills,
    productName: 'Chill Pills',
    title: 'Chill Pills',
    description:
      'Get your pup to kick back and relax with these mellowing, all-natural supplements.',
    productType: 'SP',
    subtitle: 'Calming Formula',
    size: '1 jar (60 chews)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: ChillPillsImage.src,
      alt: 'Chill Pills Supplement Image',
    },
    dropdowns: supplementsDropdownsAndValues.dropdowns,
  },
  {
    sku: addonSkus.bellyrubs,
    productName: 'Probiotic Chews',
    title: 'Probiotic Chews',
    description:
      'Say goodbye to the tummy troubles with these delicious treats.',
    productType: 'SP',
    subtitle: 'Probiotic Formula',
    size: '1 jar (60 chews)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: ProbioticsImage.src,
      alt: 'Probiotic Chews Image',
    },
    dropdowns: supplementsDropdownsAndValues.dropdowns,
  },
];

export const RecommendedPlanTreatsDropdowns = {
  dropdowns: [
    {
      name: 'quantity',
      label: 'Quantity',
      options: [{ label: '1 Bag', value: 1 }],
    },
    {
      name: 'frequency',
      label: 'Frequency',
      options: [
        { label: 'Every box', value: 1 },
        { label: 'Every other box', value: 2 },
      ],
    },
  ],
  defaultValues: {
    quantity: 1,
    frequency: 1,
  },
};

export const RecommendedPlanSupplementsDropdowns = {
  dropdowns: [
    {
      name: 'quantity',
      label: 'Quantity',
      options: [{ label: '1 Jar', value: 1 }],
    },
    {
      name: 'frequency',
      label: 'Frequency',
      options: [
        { label: 'Every box', value: 1 },
        { label: 'Every other box', value: 2 },
      ],
    },
  ],
  defaultValues: {
    quantity: 1,
    frequency: 1,
    addons: [],
  },
};

export const recommendedPlanExtras = [
  {
    sku: addonSkus.bellyrubs,
    productName: 'Probiotic Chews',
    title: 'Probiotic Chews',
    description:
      'Say goodbye to the tummy troubles with these delicious treats.',
    productType: 'SP',
    subtitle: 'Probiotic Formula',
    size: '1 jar (60 chews)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: ProbioticsImage.src,
      alt: 'Probiotic Supplement Image',
    },
    dropdowns: RecommendedPlanSupplementsDropdowns.dropdowns,
    defaultDropdownValues: RecommendedPlanSupplementsDropdowns.defaultValues,
  },
  {
    sku: addonSkus.beefjerky,
    productName: 'Beef and Sweet Potato Jerky',
    title: 'Beef and Sweet Potato Jerky',
    description:
      'Clean, simple treats to reward the best and bravest behavior.',
    productType: 'TR',
    subtitle: 'Jerky Treats',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: JerkyBeefSweetPotatoTreatOrange.src,
      alt: 'Beef and Sweet Potato Recipe Jerky Image',
    },
    dropdowns: RecommendedPlanTreatsDropdowns.dropdowns,
    defaultDropdownValues: RecommendedPlanTreatsDropdowns.defaultValues,
  },
];

export const aboutFormProps = {
  genderList: [
    { name: 'Her name is', value: 'Female' },
    { name: 'His name is', value: 'Male' },
  ],
  pupInfoQuestionCaption:
    'You can create additional pup profiles at checkout or from your account.',
  pupInfoQuestionPrompt: 'Tell us their name',
  labelName: "Your pup's name",
  index: 1,
  labelYear: 'Year',
  labelMonth: 'Month',
  labelDay: 'Day (optional)',
  pupBirthdayQuestionCaption: "If you're unsure, give us your best guess.",
  pupBirthdayQuestionPrompt: "Your pup's age",
  breedQuestionPrompt: 'What is their breed?',
  labelBreed: 'Type breed (optional)',
  idealWeightLabel: 'Pup’s ideal weight in lbs (optional)',
  weightLabel: "Pup's current weight in lbs",
  weightQuestionPrompt: "Your pup's weight",
  isPuppy: false,
  puppyIdealWeightHelp:
    'We’ll use adult weight to ensure your pup gets the right amount of food as they grow',
  puppySpayNeuterNotice:
    'Select neutered if you plan to neuter your puppy as they reach maturity.',
  idealWeightHelp:
    'If added, we’ll use this weight to determine your pup’s daily calories.',
  puppyIdealWeightLabel: "Pup's future adult weight in lbs (optional)",
  spayedChipLabel: 'Yes',
  spayedStatusQuestionCaption:
    'Spayed and neutered pups require fewer calories.',
  spayedStatusQuestionPrompt: 'Are they spayed or neutered?',
  unspayedChipLabel: 'No',
};

const poopModal = {
  heading: 'About Stool Types',
  options: [
    {
      title: 'Very Runny',
      text: 'Liquid consistency with no solid pieces.',
    },
    {
      title: 'Mushy',
      text: 'Soft, mushy consistency. Leaves lots of residue when picked up.',
    },
    {
      title: 'About Right',
      text: 'Relatively long-shaped, with cracks on surface.  Maintains shape when picked up.',
    },
    {
      title: 'Hard',
      text: 'Separate hard lumps and difficult to expel.',
    },
  ],
};

export const nutritionFormProps = {
  index: 2,
  activityQuestionPrompt: 'How active are they?',
  allergiesQuestionPrompt: 'Do they have any food allergies or sensitivities?',
  levels: [
    {
      name: 'Mellow',
      value: 'Low',
    },
    {
      name: 'Active',
      value: 'Moderate',
    },
    {
      name: 'Very active',
      value: 'High',
    },
  ],
  modal: poopModal,
  stoolTypes: [
    {
      label: 'Very runny',
      value: 'very runny',
    },
    {
      label: 'Mushy',
      value: 'mushy',
    },
    {
      label: 'About right',
      value: 'about right',
    },
    {
      label: 'Hard',
      value: 'hard',
    },
    {
      label: 'Unpredictable (It Varies)',
      value: 'unpredictable',
    },
  ],
  ctaText: 'Not sure which to choose?',
  poopSubheadline:
    "Your answer can tell us a lot about your pup's digestive health, so we can provide the best recommendations.",
  allergySearchLabel: 'Add allergies (optional)',
  poopSearchLabel: 'Select (optional)',
  emailLabel: 'Email Address',
  nameLabel: 'Name',
  userInfoQuestionPrompt: 'Before we continue',
  userInfoSubheadline:
    'Let us know about you so your recommendations can be saved',
};
